import { useParams, useNavigate } from 'react-router-dom'

export function useOrganizationEditRouting() {
  const params = useParams<{ orgId?: string }>()
  const navigate = useNavigate()
  const orgId = params.orgId ? Number(params.orgId) : undefined
  const isEdit = Boolean(orgId)

  return { navigate, orgId, isEdit }
}
